// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppEnvironmentService } from '../app-environment.service';

const contentType = 'application/json';

@Injectable({ providedIn: 'root' })
export class PriceListService {

    constructor(private readonly http: HttpClient, private readonly appEnvironmentService: AppEnvironmentService) { }

    private get baseApiUrl(): string { return this.appEnvironmentService.baseApiUrl; }

    getTenantPriceList(tenantId: number): Observable<any> {
        const accessToken = localStorage.getItem('access_token');
        const url = this.baseApiUrl + `tenants/${tenantId}/priceList`;
        const headers = new HttpHeaders({ 'Content-Type': contentType, 'Authorization': `Bearer ${accessToken}` });
        return this.http.get<any>(url, { headers });
    }
}
